// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 36px;
  padding: 6px 16px;
  border-radius: 8px;
  font-family: "OpenSans-Medium";
  font-size: 13px;
  outline: none !important;
  transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms;
}
.avo__button.btn-loading {
  cursor: default;
}
.avo__button.btn-loading .btn-content-loading {
  opacity: 0;
}
.avo__button.btn-no-text {
  padding: 10px;
  aspect-ratio: 1/1;
}
.avo__button.btn-no-text.small {
  padding: 5px;
}
.avo__button .btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: capitalize;
}
.avo__button .btn-content img {
  width: 16px;
  height: 16px;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.avo__button .loading {
  position: absolute;
}
.avo__button.primary {
  background-color: #116584;
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #116584;
  color: #ffffff;
}
.avo__button.primary:hover {
  background-color: #07506d;
}
.avo__button.primary:active {
  background-color: #062d3d;
}
.avo__button.outline {
  background-color: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #cdd5df;
  color: #116584;
}
.avo__button.outline:hover {
  background-color: #f9fafb;
}
.avo__button.outline:active {
  background-color: #ebf0f6;
}
.avo__button.outline .loading {
  border-color: #116584;
}
.avo__button.danger {
  background-color: #fef3f2;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #fecdca;
  color: #f97066;
}
.avo__button.danger:hover {
  background-color: #fee4e2;
}
.avo__button.danger:active {
  background-color: #fecdca;
}
.avo__button.danger .loading {
  border-color: #f97066;
}
.avo__button.text {
  background-color: #ffffff;
  color: #116584;
}
.avo__button.text:hover {
  color: #2d96be;
}
.avo__button.text:active {
  color: #062d3d;
}
.avo__button.text .loading {
  border-color: #116584;
}
.avo__button:disabled {
  background-color: #f9fafb;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #ebf0f6;
  color: #b6bfcb;
}
.avo__button:disabled:hover, .avo__button:disabled:active {
  background-color: #f9fafb;
}
.avo__button.small {
  height: 28px !important;
}
.avo__button.small .btn-content > img {
  width: 14px;
  height: 14px;
}
.avo__button.circle {
  border-radius: 9999px;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/button/button.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,wBAAA;EACA,8CAAA;AADJ;AAGI;EACI,eAAA;AADR;AAEQ;EACI,UAAA;AAAZ;AAII;EACI,aAAA;EACA,iBAAA;AAFR;AAGQ;EACI,YAAA;AADZ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,0BAAA;AAHR;AAKQ;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;AAHZ;AAOI;EACI,kBAAA;AALR;AAQI;EACI,yBC/CE;EDgDF,+CAAA;EACA,yBAAA;EACA,cCpDA;AD8CR;AAOQ;EACI,yBClCC;AD6Bb;AAOQ;EACI,yBCpCC;AD+Bb;AASI;EACI,yBC9DA;ED+DA,+CAAA;EACA,yBAAA;EACA,cC/DE;ADwDV;AAQQ;EACI,yBC9DC;ADwDb;AAQQ;EACI,yBChEC;AD0Db;AAQQ;EACI,qBCvEF;ADiEV;AAUI;EACI,yBCnDC;EDoDD,+CAAA;EACA,yBAAA;EACA,cClDC;AD0CT;AASQ;EACI,yBCvDH;ADgDT;AASQ;EACI,yBCzDH;ADkDT;AASQ;EACI,qBC1DH;ADmDT;AAWI;EACI,yBC9FA;ED+FA,cC7FE;ADoFV;AAUQ;EACI,cC/EC;ADuEb;AAUQ;EACI,cC/EC;ADuEb;AAUQ;EACI,qBCrGF;AD6FV;AAYI;EACI,yBCvGK;EDwGL,+CAAA;EACA,yBAAA;EACA,cCvGK;AD6Fb;AAWQ;EAEI,yBC7GC;ADmGb;AAcI;EACI,uBAAA;AAZR;AAaQ;EACI,WAAA;EACA,YAAA;AAXZ;AAeI;EACI,qBAAA;AAbR","sourcesContent":["@import '../../../styles/color';\n\n.avo__button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: fit-content;\n    height: 36px;\n    padding: 6px 16px;\n    border-radius: 8px;\n    font-family: 'OpenSans-Medium';\n    font-size: 13px;\n    outline: none !important;\n    transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms;\n\n    &.btn-loading {\n        cursor: default;\n        .btn-content-loading {\n            opacity: 0;\n        }\n    }\n\n    &.btn-no-text {\n        padding: 10px;\n        aspect-ratio: 1/1;\n        &.small {\n            padding: 5px;\n        }\n    }\n\n    .btn-content {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        text-transform: capitalize;\n\n        img {\n            width: 16px;\n            height: 16px;\n            max-width: fit-content;\n        }\n    }\n\n    .loading {\n        position: absolute;\n    }\n\n    &.primary {\n        background-color: $primary;\n        box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.12);\n        border: 1px solid $primary;\n        color: $white;\n        &:hover {\n            background-color: $primary-60;\n        }\n        &:active {\n            background-color: $primary-70;\n        }\n    }\n\n    &.outline {\n        background-color: $white;\n        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);\n        border: 1px solid $neutral-30;\n        color: $primary;\n        &:hover {\n            background-color: $neutral-10;\n        }\n        &:active {\n            background-color: $neutral-20;\n        }\n        .loading {\n            border-color: $primary;\n        }\n    }\n\n    &.danger {\n        background-color: $red-10;\n        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);\n        border: 1px solid $red-30;\n        color: $red-50;\n        &:hover {\n            background-color: $red-20;\n        }\n        &:active {\n            background-color: $red-30;\n        }\n        .loading {\n            border-color: $red-50;\n        }\n    }\n\n    &.text {\n        background-color: $white;\n        color: $primary;\n        &:hover {\n            color: $primary-40;\n        }\n        &:active {\n            color: $primary-70;\n        }\n        .loading {\n            border-color: $primary;\n        }\n    }\n\n    &:disabled {\n        background-color: $neutral-10;\n        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);\n        border: 1px solid $neutral-20;\n        color: $neutral-40;\n        &:hover,\n        &:active {\n            background-color: $neutral-10;\n        }\n    }\n\n    &.small {\n        height: 28px !important;\n        .btn-content > img {\n            width: 14px;\n            height: 14px;\n        }\n    }\n\n    &.circle {\n        border-radius: 9999px;\n    }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
